import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { solarDesignerStateKey } from '@/api/queries/project/useSolarDesignerState';
import { graphql } from '@/gql';
import { type SolarDesignerStateQuery } from '@/gql/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type SolarGeometryLocation } from './useGenerateSolarGeometry';

const StartSolarGeometryGeneration = graphql(`
  mutation StartSolarGeometryGeneration(
    $projectId: ID!
    $location: SolarLatLngInput
    $retry: Boolean
    $forceRefresh: Boolean
  ) {
    startSolarGeometryGeneration(
      projectId: $projectId
      location: $location
      retry: $retry
      forceRefresh: $forceRefresh
    ) {
      ...SolarGeometryGenerationFields
    }
  }
`);

export const useStartSolarGeometryGeneration = (
  projectId: string,
  queryProjectId: string
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      location?: SolarGeometryLocation;
      retry?: boolean;
      forceRefresh?: boolean;
    }) =>
      gqlClient.request(StartSolarGeometryGeneration, { projectId, ...input }),
    onSuccess: (data) => {
      queryClient.setQueryData<SolarDesignerStateQuery>(
        solarDesignerStateKey(queryProjectId),
        (current) =>
          current && {
            ...current,
            projectById: {
              ...current.projectById,
              solarGeometryGeneration: data.startSolarGeometryGeneration,
            },
          }
      );
      void queryClient.invalidateQueries({
        queryKey: solarDesignerStateKey(queryProjectId),
      });
      void queryClient.invalidateQueries({
        queryKey: projectKeys.overview(queryProjectId),
      });
      void queryClient.invalidateQueries({
        queryKey: projectKeys.solarPotential(queryProjectId),
      });
    },
  });
};
